import { styleEnd } from "../../algorithms/styleDirection";

const GreyBadge = ({
  containerStyle,
  count,
  describtion,
  raduis,
  backgroundColorOfCount,
}) => {
  return (
    <>
      <div className={`${containerStyle} col-2`}>
        <div
          className="d-flex justify-content-center align-items-center py-2 align-items-center"
          style={{
            borderRadius: raduis ?? 10,
            backgroundColor: "#F2F2F2",
            fontSize: 14,
          }}
        >
          <div
            className={`d-flex justify-content-center align-items-center ${styleEnd(
              "m",
              2
            )}`}
            style={{
              border: "1px solid #1A73E8",
              backgroundColor: "#1A73E8",
              color: "white",
              borderRadius: "50%",
              width: 24,
              height: 24,
              fontSize: 12,
            }}
          >
            <div className="d-flex align-self-center mt-1">{count}</div>
          </div>
          {/* <div
            style={{
              backgroundColor: backgroundColorOfCount ?? "transparent",
              borderRadius: "50%",
              color: backgroundColorOfCount ? "white" : "black",
            }}
            className="px-1 "
          >
            {count}
          </div> */}
          <div className="mt-1">{describtion}</div>
        </div>
      </div>
    </>
  );
};

export default GreyBadge;
